import url from 'url'

import twitterConfig from './TwitterConfig'

class Utils {
    static convertJsonToCsv(jsonObj) {
        // #0 sanity checks
        if (Array.isArray(jsonObj) === false) {
            return null
        }

        // #1 find headers
        const headers = []
        const headersHash = {}
        jsonObj.forEach(entry => {
            Object.keys(entry).forEach(k => {
                if (!headersHash[k]) {
                    headersHash[k] = true
                    headers.push(k)
                }
            })
        })

        // #2 add header
        const strings = [headers.join(',')]

        // #3 find values
        jsonObj.forEach(entry => {
            const line = []
            for(const key of headers) {
                var value = entry[key]
                var needsQuote = false
                if (Array.isArray(value) && value.length > 1) {
                    needsQuote = true
                }
                else if (typeof value === 'string') {
                    value = value.replace(/"/g, '""')
                    if (value.indexOf(' ') >= 0) {
                        needsQuote = true
                    }
                }
                if (needsQuote) {
                    value = '"' + value + '"'
                }
                line.push(value)
            }
            strings.push(line.join(','))
        })

        return strings.join('\n')
    }

    static isTouchDevice() {
        const ua = navigator.userAgent
        return !!(ua.match(/(iPhone|iPod|iPad)/i)
            || ua.match(/BlackBerry/i)
            || ua.match(/Android/i))
    }

    static getNotchStyle() {
        const orientation = Utils.isTouchDevice() ? Utils.getOrientation() : null
        if (orientation === 'landscape-primary') {
            // https://msdn.microsoft.com/en-us/ie/dn342934(v=vs.94)
            // The screen is in landscape mode, and the host device is right
            // side up (if its normal orientation is in landscape mode), or
            // the host device is rotated 90 degrees counter-clockwise (if its
            // normal orientation is in portrait mode).
            return 'notch-left'
        }
        else if (orientation === 'landscape-secondary') {
            // The screen is in landscape mode, and the host device is upside
            // down (if its normal orientation is in landscape mode), or the
            // host device is rotated 90 degrees clockwise (if its normal
            // orientation is in portrait mode).
            return 'notch-right'
        }
        return 'notch-upright'
    }

    static getOrientation() {
        var orientation =
            window.screen.msOrientation ||
            window.screen.mozOrientation ||
            (window.screen.orientation || {}).type

        if (orientation === undefined) {
            // it's probably on iOS Safari which doesn't support screen.orientation API yet.
            // http://www.williammalone.com/articles/html5-javascript-ios-orientation/
            if (window.orientation === 90) {
                orientation = "landscape-primary"
            }
            else if (window.orientation === -90) {
                orientation = "landscape-secondary"
            }
        }

        return orientation
    }

    static supportsDynamicImport() {
        try {
            new Function('import("")') // eslint-disable-line no-new-func
            return true
        } catch (err) {
            return false
        }
    }

    /**
     * https://developer.twitter.com/en/docs/tweets/optimize-with-cards/overview/summary
     * <meta name="twitter:card" content="summary" />  // Required
     * <meta name="twitter:site" content="@flickr" />  // Optional but Required
     * <meta name="twitter:title" content="Small Island Developing States Photo Submission" />  // Required
     * <meta name="twitter:description" content="View the album on Flickr." />  // Optional
     */
    static injectTwitterCardTags(name, description) {
        const tags = [
            {
                name: 'twitter:card',
                content: 'summary',  // hardcoded
            },
            {
                name: 'twitter:site',
                content: twitterConfig.handle,
            },
            {
                name: 'twitter:title',
                content: name,
            }
        ]
        if (description) {
            tags.push({
                name: 'twitter:description',
                content: description,
            })
        }
        tags.forEach(card => {
            Utils.injectMeta(card.name, card.content)
        })
    }
    static removeTwitterCardTags() {
        Utils.removeMeta(name => name.startsWith("twitter:"))
    }

    static injectDescription(description) {
        const tags = [
            {
                name: 'description',
                content: description,
            }
        ]
        tags.forEach(tag => {
            Utils.injectMeta(tag.name, tag.content)
        })
    }
    static removeDescription() {
        Utils.removeMeta(name => name === 'description')
    }

    static injectMeta(name, content) {
        var meta = document.createElement('meta')
        meta.name = name
        meta.content = content
        document.getElementsByTagName('head')[0].appendChild(meta)
    }
    static removeMeta(nameMatchFunc) {
        const metas = document.getElementsByTagName('meta')
        const toRemove = []
        for (var i=0; i<metas.length; i++) {
            const meta = metas[i]
            if (meta.hasAttributes() && meta.attributes.name) {
                const name = meta.attributes.name
                if (name.nodeName && name.nodeName === 'name' && nameMatchFunc(name.value) === true) {
                    toRemove.push(meta)
                }
            }
        }
        toRemove.forEach(rm => {
            const parent = rm.parentNode
            parent.removeChild(rm)
        })
    }

    static getHostName() {
        try {
            const location = url.parse(window.location.href)
            const idx = location.host.indexOf(':')
            if (idx > 0) {
                return location.host.substring(0, idx)
            }
            return location.host
        }
        catch(e) { /* do nothing */ }
        return "appler.dev" // FIXME
    }
}

export default Utils
